import React from 'react';
import { Box, CircularProgress } from '@mui/material';

// Same hosted asset the signed-in shell uses, so the loader reads as the app
// booting rather than as a blank page. See MainLayout.
const brewprksLogoUrl = 'https://assets.brewprks.com/media/images/logo-dark.svg';

/**
 * Whole-app loading state, shown while the auth bootstrap decides whether
 * anyone is signed in. Nothing route-specific belongs here — page-level
 * spinners cover each page's own data.
 */
const AppLoader: React.FC = () => (
  <Box
    sx={{
      minHeight: '100vh',
      backgroundColor: '#F4F7F9',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '28px'
    }}
  >
    <Box
      component='img'
      src={brewprksLogoUrl}
      alt='Brewprks'
      sx={{ height: 34, width: 'auto' }}
    />
    <CircularProgress size={28} sx={{ color: '#1778A8' }} />
  </Box>
);

export default AppLoader;
